// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `code[class*=language-], pre[class*=language-] {
  color: #000;
  background: 0 0;
  text-shadow: 0 1px #fff;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  tab-size: 4;
  -webkit-hyphens: none;
  hyphens: none; }

code[class*=language-] ::selection, code[class*=language-]::selection {
  text-shadow: none;
  background: #b3d4fc; }

pre[class*=language-] {
  padding: 1em;
  margin: .5em 0;
  overflow: auto; }
  pre[class*=language-] ::selection, pre[class*=language-]::selection {
    text-shadow: none;
    background: #b3d4fc; }

@media print {
  code[class*=language-], pre[class*=language-] {
    text-shadow: none; } }
:not(pre) > code[class*=language-], pre[class*=language-] {
  background: #f5f2f0; }

:not(pre) > code[class*=language-] {
  padding: .1em;
  border-radius: .3em;
  white-space: normal; }

.token.cdata, .token.comment, .token.doctype, .token.prolog {
  color: #708090; }
.token.punctuation {
  color: #999; }

.namespace {
  opacity: .7; }

.token.boolean, .token.constant, .token.deleted, .token.number, .token.property, .token.symbol, .token.tag {
  color: #905; }
.token.attr-name, .token.builtin, .token.char, .token.inserted, .token.selector, .token.string {
  color: #690; }

.language-css .token.string, .style .token.string {
  color: #a67f59;
  background: rgba(255, 255, 255, 0.5); }

.token.entity, .token.operator, .token.url {
  color: #a67f59;
  background: rgba(255, 255, 255, 0.5); }
.token.atrule, .token.attr-value, .token.keyword {
  color: #07a; }
.token.function {
  color: #DD4A68; }
.token.important, .token.regex, .token.variable {
  color: #e90; }
.token.bold, .token.important {
  font-weight: 700; }
.token.italic {
  font-style: italic; }
.token.entity {
  cursor: help; }

/*# sourceMappingURL=prism.min.css.map */
.code-box-copy {
  position: relative;
  font-size: 16px;
  display: none; }
  .code-box-copy pre[class*="language-"] {
    border: 1px solid #ddd;
    border-radius: 2px; }

.code-box-copy__btn {
  opacity: 0;
  position: absolute;
  top: 11px;
  right: 11px;
  width: 36px;
  height: 36px;
  background-color: #eee;
  border: 1px solid #ccc;
  color: #333;
  border-radius: 4px;
  transition: all 0.25s ease-in-out; }

.code-box-copy:hover .code-box-copy__btn {
  opacity: 1; }

.code-box-copy__btn:disabled {
  background-color: #eee;
  border-color: #ccc;
  color: #333;
  pointer-events: none; }
.code-box-copy__btn:hover {
  cursor: pointer;
  background-color: #fff;
  border: 1px solid #ccc;
  color: #333; }
.code-box-copy__btn:focus, .code-box-copy__btn:active {
  outline: 0; }

.code-box-copy__tooltip {
  display: none;
  position: absolute;
  bottom: calc(100% + 11px);
  right: 0;
  width: 80px;
  padding: 6px 0;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  font-size: 13px; }
  .code-box-copy__tooltip::after {
    display: block;
    position: absolute;
    right: 13px;
    bottom: -5px;
    content: ' ';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 5px 0 5px;
    border-color: #333 transparent transparent transparent; }

.card-body.show-source .code-box-copy {
  display: block; }
`, "",{"version":3,"sources":["webpack://./src/assets/css/prism.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAGhB,WAAW;EACX,qBAAqB;EAGrB,aAAa,EAAE;;AAUjB;EACE,iBAAiB;EACjB,mBAAmB,EAAE;;AAEvB;EACE,YAAY;EACZ,cAAc;EACd,cAAc,EAAE;EAChB;IACE,iBAAiB;IACjB,mBAAmB,EAAE;;AAEzB;EACE;IACE,iBAAiB,EAAE,EAAE;AACzB;EACE,mBAAmB,EAAE;;AAEvB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAE;;AAEvB;EACE,cAAc,EAAE;AAClB;EACE,WAAW,EAAE;;AAEf;EACE,WAAW,EAAE;;AAEf;EACE,WAAW,EAAE;AACf;EACE,WAAW,EAAE;;AAEf;EACE,cAAc;EACd,oCAAoC,EAAE;;AAExC;EACE,cAAc;EACd,oCAAoC,EAAE;AACxC;EACE,WAAW,EAAE;AACf;EACE,cAAc,EAAE;AAClB;EACE,WAAW,EAAE;AACf;EACE,gBAAgB,EAAE;AACpB;EACE,kBAAkB,EAAE;AACtB;EACE,YAAY,EAAE;;AAEhB,wCAAwC;AACxC;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa,EAAE;EACf;IACE,sBAAsB;IACtB,kBAAkB,EAAE;;AAExB;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAElB,iCAAiC,EAAE;;AAErC;EACE,UAAU,EAAE;;AAEd;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,oBAAoB,EAAE;AACxB;EACE,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,WAAW,EAAE;AACf;EACE,UAAU,EAAE;;AAEd;EACE,aAAa;EACb,kBAAkB;EAElB,yBAAyB;EACzB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe,EAAE;EACjB;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,sDAAsD,EAAE;;AAE5D;EACE,cAAc,EAAE","sourcesContent":["code[class*=language-], pre[class*=language-] {\n  color: #000;\n  background: 0 0;\n  text-shadow: 0 1px #fff;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  word-wrap: normal;\n  line-height: 1.5;\n  -moz-tab-size: 4;\n  -o-tab-size: 4;\n  tab-size: 4;\n  -webkit-hyphens: none;\n  -moz-hyphens: none;\n  -ms-hyphens: none;\n  hyphens: none; }\n\ncode[class*=language-] ::-moz-selection, code[class*=language-]::-moz-selection {\n  text-shadow: none;\n  background: #b3d4fc; }\n\npre[class*=language-] ::-moz-selection, pre[class*=language-]::-moz-selection {\n  text-shadow: none;\n  background: #b3d4fc; }\n\ncode[class*=language-] ::selection, code[class*=language-]::selection {\n  text-shadow: none;\n  background: #b3d4fc; }\n\npre[class*=language-] {\n  padding: 1em;\n  margin: .5em 0;\n  overflow: auto; }\n  pre[class*=language-] ::selection, pre[class*=language-]::selection {\n    text-shadow: none;\n    background: #b3d4fc; }\n\n@media print {\n  code[class*=language-], pre[class*=language-] {\n    text-shadow: none; } }\n:not(pre) > code[class*=language-], pre[class*=language-] {\n  background: #f5f2f0; }\n\n:not(pre) > code[class*=language-] {\n  padding: .1em;\n  border-radius: .3em;\n  white-space: normal; }\n\n.token.cdata, .token.comment, .token.doctype, .token.prolog {\n  color: #708090; }\n.token.punctuation {\n  color: #999; }\n\n.namespace {\n  opacity: .7; }\n\n.token.boolean, .token.constant, .token.deleted, .token.number, .token.property, .token.symbol, .token.tag {\n  color: #905; }\n.token.attr-name, .token.builtin, .token.char, .token.inserted, .token.selector, .token.string {\n  color: #690; }\n\n.language-css .token.string, .style .token.string {\n  color: #a67f59;\n  background: rgba(255, 255, 255, 0.5); }\n\n.token.entity, .token.operator, .token.url {\n  color: #a67f59;\n  background: rgba(255, 255, 255, 0.5); }\n.token.atrule, .token.attr-value, .token.keyword {\n  color: #07a; }\n.token.function {\n  color: #DD4A68; }\n.token.important, .token.regex, .token.variable {\n  color: #e90; }\n.token.bold, .token.important {\n  font-weight: 700; }\n.token.italic {\n  font-style: italic; }\n.token.entity {\n  cursor: help; }\n\n/*# sourceMappingURL=prism.min.css.map */\n.code-box-copy {\n  position: relative;\n  font-size: 16px;\n  display: none; }\n  .code-box-copy pre[class*=\"language-\"] {\n    border: 1px solid #ddd;\n    border-radius: 2px; }\n\n.code-box-copy__btn {\n  opacity: 0;\n  position: absolute;\n  top: 11px;\n  right: 11px;\n  width: 36px;\n  height: 36px;\n  background-color: #eee;\n  border: 1px solid #ccc;\n  color: #333;\n  border-radius: 4px;\n  -webkit-transition: all 0.25s ease-in-out;\n  transition: all 0.25s ease-in-out; }\n\n.code-box-copy:hover .code-box-copy__btn {\n  opacity: 1; }\n\n.code-box-copy__btn:disabled {\n  background-color: #eee;\n  border-color: #ccc;\n  color: #333;\n  pointer-events: none; }\n.code-box-copy__btn:hover {\n  cursor: pointer;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  color: #333; }\n.code-box-copy__btn:focus, .code-box-copy__btn:active {\n  outline: 0; }\n\n.code-box-copy__tooltip {\n  display: none;\n  position: absolute;\n  bottom: -webkit-calc(100% + 11px);\n  bottom: calc(100% + 11px);\n  right: 0;\n  width: 80px;\n  padding: 6px 0;\n  background-color: #333;\n  color: #fff;\n  text-align: center;\n  border-radius: 2px;\n  font-size: 13px; }\n  .code-box-copy__tooltip::after {\n    display: block;\n    position: absolute;\n    right: 13px;\n    bottom: -5px;\n    content: ' ';\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 5px 5px 0 5px;\n    border-color: #333 transparent transparent transparent; }\n\n.card-body.show-source .code-box-copy {\n  display: block; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
